
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Robert André L., 99 ans, décédé le 7 avril 2020</b>
    <br />
    <br />
    <i>Sa belle-fille s’exprime:</i>
    <br />
    <p>
  «Mon beau-père était une personnalité forte, attachante et charmante. Il s’est
  porté comme un charme jusqu’à l’âge de 90 ans. Puis il a commencé à décliner.
  Il s’en inquiétait. Il avait parfois de la peine à l’accepter. Il a toujours
  su ce qu’il se voulait et se donnait les moyens de l’obtenir. Par exemple, il
  s’est battu pour conserver son permis de conduire le plus longtemps possible.
  Il a vécu le fait qu’on lui retire comme une profonde injustice, il pensait
  que son âge avancé n’était pas une raison suffisante. Il était radioamateur et
  avait installé une antenne sur le toit de sa maison. Il parvenait ainsi à
  communiquer avec des gens dans le monde entier. Mon beau-père était très
  cultivé. Le coronavirus ne l’inquiétait pas plus que cela. Il était dans une
  maison de retraite lorsqu’il a appris qu’il était positif. Le virus avait été
  détecté dans l'établissement et la direction avait décidé de tester tous les
  résidents. Il est décédé quelques jours après. C’était quelques jours après
  ses 99 ans. Je ne sais pas s’il est mort précisément du virus. Qui peut le
  savoir? Il aurait pu mourir d’autre chose, d’une autre maladie. Il était déjà
  très affaibli. Il n’avait plus la force de lutter contre le coronavirus. Il
  souffrait, entre autres, d’insuffisance cardiaque. Une fois que le virus s’est
  déclaré, tout s’est passé très rapidement. En quelques jours seulement. Pas
  plus d’une semaine, en tout cas. C’était très rapide.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;